import qrcode from "qrcode-generator";
import { useMemo } from "react";

/**
 * QR Code em SVG (sem innerHTML): um path com os módulos escuros, margem de 4 módulos (zona de silêncio) e fundo
 * branco também no tema escuro, como os apps bancários esperam. Correção de erro "M", como recomenda o BR Code.
 */
export function QrCode({ value, size = 220, label }: { value: string; size?: number; label: string }) {
  const { d, n } = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(value, "Byte");
    qr.make();
    const count = qr.getModuleCount();
    let path = "";
    for (let r = 0; r < count; r++)
      for (let c = 0; c < count; c++) if (qr.isDark(r, c)) path += `M${c + 4} ${r + 4}h1v1h-1z`;
    return { d: path, n: count + 8 };
  }, [value]);
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${n} ${n}`}
      shapeRendering="crispEdges"
      style={{ background: "#fff", borderRadius: 4 }}
    >
      <rect width={n} height={n} fill="#fff" />
      <path d={d} fill="#000" />
    </svg>
  );
}
